import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=b02d4188"
import script from "./welcome.ts?vue&type=script&lang=js&external"
export * from "./welcome.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports